<!-- 任务列表任务定时状态显示 -->
<template>
    <div class="function-schdule">
        <el-switch :value="isSchedule" class="schdule-switch" active-color="#386EE4" inactive-color="#C1CBE3" @change="clickBtn($event)"></el-switch>
        <span class="schdule-txt" :style="isSchedule?'':'color: #8A8C99;'" @click="openPopup(7)">{{showSchedule}}</span>
    </div>
</template>

<script>
export default {
    props: ['task'],
    computed: {
        //获取显示内容
        showSchedule() {
            var res = this.$t('language.common.schedule')+": ";
            if(this.task.schedules && this.task.schedules.times){
                res += this.getScheduleText(this.task.schedules,this.task.schedules.type);
            }else{
                res += this.$t('language.twoStepverification.off');
            }
            return res;
        },
        isSchedule() {
            return this.task.schedules?(!this.task.schedules.disabled):true;
        }
    },
    data: function() {
        return {
        }
    },
    methods: {
        //点击switch按钮事件
        clickBtn() {
            console.log(this.task.schedules)
            if(!this.task.schedules.disabled && !this.task.schedules.type && !this.task.schedules.times){
                //未设置定时任务,则打开定时任务窗口
                this.openPopup();
            }else {
                //执行修改定时任务
                this.$emit("update",this.task);
            }
        },
        //打开对应功能弹出窗口
        openPopup() {
            /*  type参数:
                7: 打开定时任务设置弹窗
             */
            //打开弹窗
            this.$emit("open-popup",7,this.task);
        },
        //获取显示内容
        getScheduleText(schedules,type) {
            let res = "";
            if(type === "Once" || type === "=Once") {
                res += " "+this.$t('language.popup.once')+" ";
                let date = new Date(schedules.date);
                res += (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + " ";
                res += schedules.times[0];
            }else if(type === "Daily" || type === "=Daily") {
                res += " "+this.$t('language.popup.daily')+" ";
                res += schedules.times.join(', ');
            }else if(type === "Weekly" || (type === "=Weekly" && schedules.weeks)) {
                res += " "+this.$t('language.popup.weekly')+" ";
                var weeks = schedules.weeks;
                var weeksSet = [];
                var length = weeks.length>4?4:weeks.length;
                for (let i = 0; i < length; i++) {
                    var week = this.$t('language.schedule.week' + weeks[i]);
                    weeksSet.push(week);
                }
                res += weeksSet.join(', ');
                if(weeks.length>4){
                    res += "...";
                }
                res += (" " + schedules.times[0]);
            }else if(type === "Monthly" || type === "=Monthly") {
                res += " "+this.$t('language.popup.monthly')+" ";
                var days = schedules.days;
                var daysSet = [];

                //特殊处理同步任务可能出现的首位空值
                if(days[0]!=0 && !days[0]) {
                    days = days.slice(1);
                }

                var length = days.length>7?7:days.length;
                var lastDay = null;
                console.log(days)
                for (let i = 0; i < length; i++) {
                    const day = days[i];
                    if(day == "") {
                        //空的情况跳过
                        continue;
                    }
                    var remainder = day%10;
                    var that = this;
                    switch (remainder) {
                        case 1:
                            daysSet.push(day + 'st');
                            break;
                        case 2:
                            daysSet.push(day + 'nd');
                            break;
                        case 3:
                            daysSet.push(day + 'rd');
                            break;
                        default:
                            if(day!=0) {
                                daysSet.push(day + 'th');
                            }else if(days.length<=7){
                                lastDay = that.$t('language.popup.lastDay');
                            }
                            break;
                    }
                }
                if(lastDay) {
                    daysSet.push(lastDay);
                }
                res += daysSet.join(', ');
                if(days.length>7){
                    res += "...";
                }
                res += (" " + schedules.times[0]);
            }
            return res;
        }
    }
}
</script>

<style scoped>
.function-schdule {
    display: flex;
    align-items: center;
}

.schdule-switch {

}

.schdule-txt {
    font-family: Roboto;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 18px;
    /*no*/
    letter-spacing: 0em;
    margin-left: 8px;
    /*no*/
}

.schdule-txt:hover {
    text-decoration: underline;
    cursor: pointer;
}

.grid-schdule {
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tab_task_schdule.vue